/* Simply Food Storage — eased open/close for the homepage FAQ accordion.
   Progressive enhancement over native <details name="..."> (instant, exclusive
   open, works with JS off); this animates the height and keeps exclusivity
   since preventDefault() on the click stops the browser's native toggle.
   Case: without this, opening/closing snaps abruptly. */
(function () {
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduceMotion || typeof Element === 'undefined' || !Element.prototype.animate) return;

  var groups = {};

  function Accordion(details) {
    this.details = details;
    this.summary = details.querySelector('summary');
    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;
    details._sfsFaqAccordion = this;

    var groupName = details.getAttribute('name');
    if (groupName) {
      groups[groupName] = groups[groupName] || [];
      groups[groupName].push(this);
    }

    this.summary.addEventListener('click', this.onClick.bind(this));
  }

  Accordion.prototype.onClick = function (event) {
    event.preventDefault();
    this.details.style.overflow = 'hidden';

    if (this.isClosing || !this.details.open) {
      this.open();
    } else if (this.isExpanding || this.details.open) {
      this.shrink();
    }
  };

  Accordion.prototype.shrink = function () {
    this.isClosing = true;
    var startHeight = this.details.offsetHeight + 'px';
    var endHeight = this.summary.offsetHeight + 'px';

    if (this.animation) this.animation.cancel();

    this.animation = this.details.animate(
      { height: [startHeight, endHeight] },
      { duration: 250, easing: 'ease-out' }
    );
    this.animation.onfinish = this.onAnimationFinish.bind(this, false);
    this.animation.oncancel = function () {
      this.isClosing = false;
    }.bind(this);
  };

  Accordion.prototype.open = function () {
    var groupName = this.details.getAttribute('name');
    if (groupName && groups[groupName]) {
      groups[groupName].forEach(
        function (other) {
          if (other !== this && other.details.open) other.shrink();
        }.bind(this)
      );
    }

    this.details.style.height = this.details.offsetHeight + 'px';
    this.details.open = true;
    window.requestAnimationFrame(this.expand.bind(this));
  };

  Accordion.prototype.expand = function () {
    this.isExpanding = true;
    var startHeight = this.details.offsetHeight + 'px';
    var content = this.details.querySelector('.sfs-faq__answer');
    var endHeight = this.summary.offsetHeight + (content ? content.offsetHeight : 0) + 'px';

    if (this.animation) this.animation.cancel();

    this.animation = this.details.animate(
      { height: [startHeight, endHeight] },
      { duration: 250, easing: 'ease-out' }
    );
    this.animation.onfinish = this.onAnimationFinish.bind(this, true);
    this.animation.oncancel = function () {
      this.isExpanding = false;
    }.bind(this);
  };

  Accordion.prototype.onAnimationFinish = function (open) {
    this.details.open = open;
    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;
    this.details.style.height = '';
    this.details.style.overflow = '';
  };

  document.querySelectorAll('.sfs-faq details').forEach(function (details) {
    new Accordion(details);
  });
})();
